import { Component } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AdministratorService } from '../../../../services/administrator.service';


@Component({
  selector: 'app-create-unit-of-measure',
  standalone: true,
  imports: [SharedModule, CommonModule],
  providers:[MessageService],
  templateUrl: './create-unit-of-measure.component.html',
  styleUrl: './create-unit-of-measure.component.scss'
})
export class CreateUnitOfMeasureComponent {

  constructor(private messageService: MessageService , private router:Router, private routers: ActivatedRoute, private unitsOfMeasureService:AdministratorService) { }

  submitted: boolean = false;
  isEditMode: boolean = false;
  unitOfMeasureId: number | undefined;
 

  
  createUnitOfMeasureForm = new FormGroup({
    unitsofMeasureCode: new FormControl('', Validators.required),
    unitsofMeasure: new FormControl('', Validators.required),
    unitsofMeasureDescription: new FormControl('', Validators.required),
    // CheckBox
    isActive: new FormControl(true,Validators.requiredTrue),
    createdBy: new FormControl(''),
    updatedBy: new FormControl(''),
  });

  
  ngOnInit(): void {
  document.title = 'Create Unit of Measure';
  this.getit();
  this.createUnitOfMeasureForm.controls.createdBy.setValue(localStorage.getItem('username'));
  }
 

  getit(){
    this.routers.queryParams.subscribe(params => {
      this.unitOfMeasureId = params['unitOfMeasureId'];
      this.isEditMode = !!this.unitOfMeasureId;

      if (this.isEditMode) {
        // If in edit mode, fetch the salesperson details
        this.unitsOfMeasureService.getUnitsOfMeasureId(this.unitOfMeasureId).subscribe(
          ( unitOfMeasure: any) => {
            if (unitOfMeasure) {
              document.title = 'Update Unit of Measure';
              this.createUnitOfMeasureForm.patchValue(unitOfMeasure);
            } else {
              console.error('Unit of Measure data not found.');
            }
          },
          (error: any) => {
            console.error('Error fetching Unit of Measure data:', error);
            console.error(error);
          }
        );
      }else{
        this.resetForm();
      }
    });
  }
  resetForm() {
    this.createUnitOfMeasureForm.reset();
    this.createUnitOfMeasureForm.controls.isActive.setValue(true);
  }


  get formControls() {
    return this.createUnitOfMeasureForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.createUnitOfMeasureForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }

  saveUnitOfMeasure(data: any, isEditMode: boolean) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }
    if (isEditMode) {
      this.updateUnitOfMeasure();
    } else {
      this.createUnitOfMeasure(data);
    }
  }

  updateUnitOfMeasure() {
    this.submitted = true;
  const isValid = this.validateForm();
  if(!isValid) {
    return;
  }
     let updatedBy = localStorage.getItem('username');
     const data = {
      unitsofMeasureId: this.unitOfMeasureId,
      unitsofMeasureCode: this.createUnitOfMeasureForm.controls.unitsofMeasureCode.value,
      unitsofMeasure: this.createUnitOfMeasureForm.controls.unitsofMeasure.value,
      unitsofMeasureDescription: this.createUnitOfMeasureForm.controls.unitsofMeasureDescription.value,
      isActive: this.createUnitOfMeasureForm.controls.isActive.value,
      UpdatedBy : updatedBy,
     };
     if (data) {
      this.unitsOfMeasureService.updateUnitsOfMeasure(data).subscribe({
        next: data => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Unit of measure Updated Successfully.' });
          setTimeout(() => {
            this.router.navigate(['/home/listUnitsOfMeasure']);
          }, 1000);
        },
        error: error => {
        }
     });
      }
      else{
        this.createUnitOfMeasure(data);
      }  
  }


  createUnitOfMeasure(data: any){
    this.createUnitOfMeasureForm.controls.createdBy.setValue(localStorage.getItem('username'));
    this.submitted = true;
    const isValid = this.validateForm();
    if(!isValid) {
      return;
    }
    this.unitsOfMeasureService.createUnitsOfMeasure(data).subscribe({
      next: data => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Unit of measure Created Successfully.' })
        setTimeout(() => {
          this.router.navigate(['/home/listUnitsOfMeasure']);
        }, 1000);
      },
      error: error => {
  
      }
    })
  
  }

  Cancel(){
    this.router.navigate(['/home/listUnitsOfMeasure']);
  }
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }
}
